import './chatArea.css';
import Markdown from 'react-markdown';
import { useRef, useEffect, useMemo } from 'react';
import rehypeRaw from 'rehype-raw';
import Rating from '../Rating';

function ChatArea(props) {
    const { chatLog, fetchingAwnser } = props;
    const afterLastMessage = useRef(null);

    const scrollDown = () => {
        afterLastMessage.current?.scrollIntoView();
    }

    const storeId =  useMemo(() => {
        return window.localStorage.getItem('storeId') || '#';
    }, [])

    const rater = (type) => {
        if ('response' !== type) {
            return null;
        }

        return <>
            <hr/>
        </>
    }

    useEffect(() => {
        scrollDown();
    }, [chatLog]);

    const view = chatLog.map((element, index) =>
        <div className={`bubble-container ${element.message.type}`} key={index}>
            <div className='avatar'>
                {element.message.type === 'response' ? <p>AI</p> : <p>{storeId}</p>}
            </div>
            <div className='chat-bubble' id={element.message.type}>
                <div>
                    <Markdown rehypePlugins={[rehypeRaw]}>{element.message.content}</Markdown>
                    {rater(element.message.type)}
                    <Rating messageId={element?.message?.id}/>
                </div>
            </div>
        </div>
    );

    const threeDots = () => {
        if (!fetchingAwnser) {
            return null;
        }
        return (
            <div className='three-dots-container'>
                <div className='avatar'>
                    <p>AI</p>
                </div>
                <div className="col-3">
                    <div className="snippet" data-title="dot-typing">
                        <div className="stage">
                            <div className="dot-typing"></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className='chatarea'>
            <div className='chatarea-container'>
                {view}
                {threeDots()}
                <div ref={afterLastMessage} />
            </div>
        </div>
    );
}

export default ChatArea;
